import { useCabinetText } from '../../i18n/CabinetLocale';
import React from 'react';
import DraftRecoveryNotice from './DraftRecoveryNotice';

export default function FormDraftNotice({ buffer, label, hidden = false, onResume, disabled = false }) {
  const t = useCabinetText();
  return <>
    <DraftRecoveryNotice buffer={buffer} label={label} disabled={disabled} onRestore={onResume} />
    {!buffer.recovery && buffer.count > 0 && <div className="ap-save-notice" role="status"><div>
      <strong>{label}{' '}{t(": есть несохранённые изменения")}</strong>
      <p>{buffer.storageError ? t("Пока они доступны только на экране.") : t("Резервный черновик сохранён в этой вкладке. На сервер изменения попадут только после сохранения формы.")}</p>
      {hidden && onResume && <button type="button" className="ap-button ap-button--secondary ap-button--sm" disabled={disabled} onClick={onResume}>{t("Продолжить заполнение")}</button>}
    </div></div>}
  </>;
}
